import {
  getChargeTripEndpoint,
  getChargeTripWSTransportEndpoint,
  getAuthenticationHeader,
} from "./helpers";
import type {
  Client,
  ClientPluginContext,
  SubscriptionForwarder,
} from "villus";
import { useClient, handleSubscriptions, cache, dedup } from "villus";
import { batch } from "@villus/batch";
import { createClient as createWSClient } from "graphql-ws";

const wsClient = createWSClient({
  url: getChargeTripWSTransportEndpoint(),
  lazy: true,
  keepAlive: 5000,
  retryAttempts: 3,
  connectionParams: async () => {
    return {
      ...(await getAuthenticationHeader()),
    };
  },
});

const subscriptionForwarder: SubscriptionForwarder = (operation) => {
  return {
    subscribe: (obs): { unsubscribe: () => void } => {
      const unsubscribe = wsClient.subscribe(
        {
          query: operation.query,
          variables: {
            ...operation.variables,
          },
        },
        obs,
      );

      return {
        unsubscribe,
      };
    },
  };
};

const authPlugin = async (ctx: ClientPluginContext): Promise<void> => {
  const { opContext } = ctx;

  opContext.headers = {
    ...opContext.headers,
    ...(await getAuthenticationHeader()),
  };
};

export const initVillus = (): Client => {
  return useClient({
    url: getChargeTripEndpoint(),
    cachePolicy: "cache-first",
    use: [
      authPlugin,
      handleSubscriptions(subscriptionForwarder),
      cache(),
      dedup(),
      batch(),
    ],
  });
};
